"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressiveEquip_exports = {};
__export(ProgressiveEquip_exports, {
  default: () => ProgressiveEquip_default
});
module.exports = __toCommonJS(ProgressiveEquip_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.8 1.53C12.4303 1.53 11.32 2.64033 11.32 4.01L10.08 4.01C7.34066 4.01 5.12 6.23067 5.12 8.97V35.01C5.12 37.7493 7.34066 39.97 10.08 39.97H29.92C32.6593 39.97 34.88 37.7493 34.88 35.01V8.97C34.88 6.23067 32.6593 4.01 29.92 4.01H28.68C28.68 2.64033 27.5697 1.53 26.2 1.53H13.8Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.6699 17.5827L15.6243 26.3389C15.2225 27.4939 13.6102 27.5505 13.1285 26.4265L11.9712 23.7261H9.98327C9.36692 23.7261 8.86727 23.2264 8.86727 22.6101C8.86727 21.9937 9.36692 21.4941 9.98327 21.4941H12.5599C13.0956 21.4941 13.5798 21.8133 13.7908 22.3057L14.2728 23.4303L17.5452 14.0222C17.9824 12.7653 19.7865 12.8464 20.1093 14.1374L23.66 28.3406L26.7132 22.2344C26.94 21.7807 27.4037 21.4941 27.911 21.4941H30.5631C31.1794 21.4941 31.6791 21.9937 31.6791 22.6101C31.6791 23.2264 31.1794 23.7261 30.5631 23.7261H28.4628L24.5771 31.4975C24.021 32.6095 22.3816 32.4296 22.08 31.2234L18.6699 17.5827Z",
      fill: "#407177"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.32 4.01C11.32 2.64033 12.4303 1.53 13.8 1.53H26.2C27.5697 1.53 28.68 2.64033 28.68 4.01H29.92C32.6593 4.01 34.88 6.23067 34.88 8.97V35.01C34.88 37.7493 32.6593 39.97 29.92 39.97H10.08C7.34066 39.97 5.12 37.7493 5.12 35.01V8.97C5.12 6.23067 7.34066 4.01 10.08 4.01L11.32 4.01ZM13.8 3.018H26.2C26.7479 3.018 27.192 3.46213 27.192 4.01V5.25C27.192 5.79787 26.7479 6.242 26.2 6.242H13.8C13.2521 6.242 12.808 5.79787 12.808 5.25V4.01C12.808 3.46213 13.2521 3.018 13.8 3.018ZM11.3322 5.498H10.08C8.16246 5.498 6.608 7.05247 6.608 8.97V35.01C6.608 36.9275 8.16246 38.482 10.08 38.482H29.92C31.8375 38.482 33.392 36.9275 33.392 35.01V8.97C33.392 7.05247 31.8375 5.498 29.92 5.498H28.6678C28.5433 6.75122 27.486 7.73 26.2 7.73H13.8C12.514 7.73 11.4567 6.75122 11.3322 5.498Z",
      fill: "currentColor"
    }
  )
);
const SvgProgressiveEquip = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ProgressiveEquip_default = SvgProgressiveEquip;
